export default __webpack_public_path__ + "static/media/rabbitline_logo.dbcb6584.svg";